import { jsx as e } from "react/jsx-runtime";
import i from "./roche-date.module.scss.js";
const s = ({ displayDate: t, dateTimeValue: r }) => /* @__PURE__ */ e("div", { className: i.date, children: /* @__PURE__ */ e("time", { dateTime: r, children: t }) });
export {
  s as RocheUIDate
};
